import service from '@/store/services/employers/work-details-service';

const state = {
    list: {},
    workDetail: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, workDetail) => {
        state.workDetail = workDetail;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(workDetail => {
                commit('SET_RESOURCE', workDetail);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(workDetail => {
                commit('SET_RESOURCE', workDetail);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((workDetail) => {
                commit('SET_RESOURCE', workDetail);
            });
    },

    update({ commit }, params) {
        return service.update(params)
            .then((workDetail) => {
                commit('SET_RESOURCE', workDetail);

                return workDetail;
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    workDetail: state => state.workDetail,
    dropdown: (state) => {
        return state.list.map(workDetail => ({
            id: workDetail.id,
            name: workDetail.comodity,
        }));
    }
};

const workDetails = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default workDetails;
